<template>
  <div>
    <b-button v-b-modal.add_event variant="primary" class="mb-3">
      <b-icon icon="calendar-plus" class="mr-2" />New Event
    </b-button>
    <b-modal
      ref="add_event"
      id="add_event"
      size="lg"
      title="New Event"
      @shown="focusTitle"
      @hide="hideModal"
    >
      <b-alert variant="danger" show v-if="isError">An error occurred while submitting.</b-alert>
      <b-form-group label="Title">
        <b-form-input
          ref="focusThis"
          v-model="event.title"
          size="lg"
          placeholder="Enter event title"
        />
      </b-form-group>
      <b-form-group label="Description">
        <b-textarea v-model="event.description" rows="4" placeholder="Brief event description..."></b-textarea>
      </b-form-group>
      <b-form-group label="Location">
        <b-form-input ref v-model="event.location" placeholder="Event venue" />
      </b-form-group>
      <b-form-group label="Start Date">
        <b-form-datepicker
          v-model="event.start"
          locale="en-US"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          :min="today"
        ></b-form-datepicker>
      </b-form-group>
      <b-form-group label="End Date">
        <b-form-datepicker
          v-model="event.end"
          locale="en-US"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          :min="event.start || today"
        ></b-form-datepicker>
      </b-form-group>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="hideModal">Cancel</b-button>
        <b-button variant="success" class="mr-2" @click.prevent="submit()" :disabled="sending">
          <b-spinner v-if="sending" small></b-spinner>
          <em v-else>
            <i class="fas fa-paper-plane"></i>
          </em>
          Submit
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      today: new Date(),
      event: {
        title: "",
        description: "",
        location: "",
        start: moment(this.today).format("YYYY-MM-DD"),
        end: moment(this.today).format("YYYY-MM-DD")
      },
      sending: false,
      isError: false
    };
  },
  computed: {},
  watch: {
    "event.start": {
      handler: function(val, oldVal) {
        if (this.event.end < val) {
          this.event.end = val;
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({ createEvent: "calendar/create" }),
    showModal() {
      this.$refs.add_event.show();
    },
    submit() {
      this.sending = true;
      let vm = this;
      this.createEvent(this.event)
        .then(res => {
          vm.hideModal();
          this.makeToast(
            "success",
            "Saved",
            "Event " + res.title + " has been saved!"
          );
        })
        .catch(err => {
          console.log(err);
          this.isError = true;
        })
        .then(() => {
          this.sending = false;
        });
    },
    focusTitle() {
      this.$refs.focusThis.focus();
    },
    hideModal() {
      this.$refs["add_event"].hide();
      this.isError = false;
      this.sending = false;
      this.event = {
        title: "",
        description: "",
        start: moment(this.today).format("YYYY-MM-DD"),
        end: moment(this.today).format("YYYY-MM-DD")
      };
    }
  }
};
</script>

<style>
</style>